import type { z } from "zod";

import { SortFields, zSchema } from "../../../../entity";

import { ListParams, Pagination } from "~/shared/zod";

const zIn = ListParams.zSchema(SortFields.zSchema);
type In = z.infer<typeof zIn>;

const zOut = Pagination.Page.zSchema(zSchema);
type Out = z.infer<typeof zOut>;

export { zIn, zOut };
export type { In, Out };
